import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserAdd, UserPlatform, UserUpdate } from '@classes/user/user-platform';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import * as FileSaver from 'file-saver';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UsersService {

  constructor(
    private http: HttpClient
  ) { }

  /* ----------------------------------- GET ---------------------------------- */

  getUser(): Observable<UserPlatform[]> {
    return this.http.get<UserPlatform[]>(`${environment.apiUrl}/users`, {
      headers: { authorization: `Bearer ${localStorage.getItem(environment.tokenKey)}` }
    });
  }

  getPhotoUser(id: string): Observable<Blob> {
    return this.http.get(`${environment.apiUrl}/users/${id}/photo`, {
      observe: 'response', responseType: 'blob', headers: { authorization: `Bearer ${localStorage.getItem(environment.tokenKey)}` }
    })
      .pipe(map(res => res.body));
  }


  /* -------------------------------------------------------------------------- */


  /* ---------------------------------- POST ---------------------------------- */

  addUser(user: UserAdd): Observable<UserAdd> {
    return this.http.post<UserAdd>(`${environment.apiUrl}/users`, user);
  }

  /* -------------------------------------------------------------------------- */


  /* ----------------------------------- PUT ---------------------------------- */

  updateUser(user: UserUpdate): Observable<UserUpdate> {
    return this.http.put<UserUpdate>(`${environment.apiUrl}/users`, user);
  }

  activateUser(id: string) {
    return this.http.put(`${environment.apiUrl}/users/${id}/activate`, null);
  }

  desactivateUser(id: string) {
    return this.http.put(`${environment.apiUrl}/users/${id}/deactivate`, null);
  }

  updatePhotoUser(id: string, file: File) {
    const formData = new FormData();
    formData.append('file', file, file.name);
    return this.http.put(`${environment.apiUrl}/users/${id}/photo`, formData);
  }

  /* -------------------------------------------------------------------------- */

  /* --------------------------------- DELETE --------------------------------- */


  /* -------------------------------------------------------------------------- */


}
